<div>
  <input
    style="display: none"
    type="file"
    accept=".pdf,.doc,.docx,.xls,.xlsx,image/jpeg,image/png,.eml"
    multiple
    (change)="onFileSelected($event)"
    #fileUpload
  />

  <div style="display: flex; justify-content: center">
    <button
      class="buttonPrimary"
      style="min-width: 186px"
      (click)="fileUpload.click()"
    >
      <div class="div-center row-base" style="gap: 4px">
        Cargar Archivos

        <i-tabler style="color: white" name="upload" class="icon-20"></i-tabler>
      </div>
    </button>
  </div>
</div>

<div
  style="
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 20px;
    padding-top: 20px;
  "
>
  <div
    style="width: 100%; display: flex; justify-content: center; gap: 10px"
    *ngFor="let multimedia of multimedia; let i = index"
  >
    <div
      style="
        background-color: white;
        width: 40rem;
        border: solid;
        border-color: rgba(0, 0, 0, 0.12);
        border-width: 1px;
        border-radius: 10px;
        align-items: center;
        padding: 12px;
      "
    >
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div>{{ multimedia.name }}</div>

        <div style="display: flex; justify-content: center; gap: 10px">
          <button
            mat-icon-button
            (click)="deleteMultimediaLocal(multimedia, i)"
          >
            <mat-icon class="icon-color">delete</mat-icon>
          </button>
          <button mat-icon-button (click)="activatePDF(multimedia, i)">
            <mat-icon class="icon-color">photo</mat-icon>
          </button>
          <button
            *ngIf="multimedia.key"
            mat-icon-button
            (click)="downloadFile(multimedia)"
          >
            <mat-icon class="icon-color">download</mat-icon>
          </button>
        </div>
      </div>

      <div
        style="display: flex; justify-content: center"
        *ngIf="pdfViewer && index == i"
      >
        <iframe
          *ngIf="!multimedia.htmlContent"
          [src]="url"
          width="600"
          height="400"
        ></iframe>

        <div
          *ngIf="multimedia.htmlContent"
          [innerHTML]="multimedia.htmlContent"
          style="
            width: 600px;
            height: 400px;
            overflow: auto;
            border: 1px solid #ccc;
            padding: 8px;
          "
        ></div>
      </div>
    </div>
  </div>
</div>
